var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "date-inputs-container" }, [
    _c(
      "div",
      { staticClass: "date-input-wrapper" },
      [
        _c("h5", [_vm._v(_vm._s(_vm.label))]),
        _c(
          "md-field",
          { staticClass: "date-field" },
          [
            _c("md-datepicker", {
              attrs: { "md-immediately": "", "md-debounce": 100 },
              model: {
                value: _vm.date,
                callback: function ($$v) {
                  _vm.date = $$v
                },
                expression: "date",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }